export default __webpack_public_path__ + "static/media/totals-chart-empty.9b9ee5d1.webp";